import { useEffect, useState } from 'react';

import HeaderStore from 'components/Store/HeaderStore/HeaderStore';
import Discover from 'components/Store/Discover/Discover';
import Books from 'components/Store/Books/Books';
import Courses from 'components/Store/Courses/Courses';
import Udc from 'components/Store/Udc/Udc';
import Loading from 'uI/Loading/Loading';
// import FabMenu from 'uI/FabMenu/FabMenu';

import { getStoreItems } from 'store/store-actions';

const Store = () => {
  const [section, setSection] = useState('all');
  const [loading, setLoading] = useState(true);
  const [itemsStore, setItemsStore] = useState({});
  const [searchText, setSearchText] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(0);

  useEffect(() => {
    const url = window.location.pathname.split('/');
    setSection(url[2] ? url[2] : 'all');
  }, []);

  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);
    setTypingTimeout(
      setTimeout(() => {
        (async () => {
          setItemsStore(
            await getStoreItems(
              searchText.length > 0 ? [searchText] : null
            )
          );
          setLoading(false);
        })();
      }, 800)
    );
  }, [searchText]);

  const changeSectionHandler = section => {
    setSection(section);
  };

  const searchHandler = searchValue => {
    setSearchText(searchValue);
  };

  return (
    <>
      {!loading ? (
        <>
          <HeaderStore
            changeSection={changeSectionHandler}
            section={section}
            searchHandler={searchHandler}
          />
          {section === 'all' ? (
            <Discover
              itemsStore={itemsStore}
              changeSection={changeSectionHandler}
            />
          ) : section === 'books' ? (
            <Books itemsStore={itemsStore.books.list} />
          ) : section === 'courses' ? (
            <Courses itemsStore={itemsStore.coursesCerts.list} />
          ) : section === 'degrees' ? (
            <Udc degrees />
          ) : (
            <Udc />
          )}
          {/* <FabMenu section="store" /> */}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Store;
